module.exports = __webpack_public_path__ + "img/teases-logo.2dce8285.jpg";